<template>
  <transition name="fade" @after-leave="handleAfterLeave">
    <div class="sl-notification" :class="[site, customClass, leaveClass]" :style="upDown">
      <div class="sl-notification__group">
        <h2 class="sl-notification__title" v-if="title">{{ title }}</h2>
      
        <div class="sl-notification__content" v-if="!dangerouslyUseHTMLString">
          <p>{{message}}</p>
        </div>
        <div class="sl-notification__content" v-else v-html="message"></div>
        <div class="sl-notification__close" v-if="closeBtn" @click="removeChildEle">{{ closeBtn }}</div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Notification',
  data(){
    return {
      visible: false,
      title: "",
      message: "",
      position: 'top-right',
      dangerouslyUseHTMLString: false, //默认false ---使用HTML片段
      showClose: false,
      closeBtn: '',
      customClass: "",
      duration: 4500,
      timer: null,
      leaveClass: 'sl-notification-fade-enter'
    }
  },
  created(){
    
  },
  mounted(){
    this.startTimer()
  },
  computed: {
    site(){
      let str = this.position
      return str.substr(str.indexOf("-") + 1, str.length)
    },
    upDown(){
      let str = this.position
      str = str.substr(0, str.indexOf("-"))
      return str === 'top' ? { top: "109px" } : { bottom: "109px" }
    }
  },
  methods: {
    handleAfterLeave(){
      console.log('handleAfterLeave')
    },
    startTimer(){
      setTimeout(() => {
        this.leaveClass = ''
      }, 500)
      if(this.duration > 0){
        this.timer = setTimeout(()=> {
          this.removeChildEle()
          clearTimeout(this.timer)
        }, this.duration)
      }
    },
    removeChildEle(){
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>
<style scoped lang="scss">
  .sl-notification {
    // display: flex;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
    border: 1px solid #ebeef5;
    position: fixed;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    min-width: 130px;
    overflow: hidden;
    z-index: 10001;
    padding: 14px 26px 14px 13px;
    &.right {
      right: 16px;
    }
    &.left {
      left: 16px;
    }
    .sl-notification__group {
      margin-left: 13px;
      margin-right: 8px;
      .sl-notification__title {
        font-weight: 700;
        font-size: 16px;
        color: #303133;
        margin: 0;
      }
      .sl-notification__content {
        font-size: 14px;
        line-height: 21px;
        margin: 6px 0 0;
        color: #606266;
        text-align: justify;
      }
    }
    &.sl-notification-fade-enter.right {
      right: 0;
      transform: translateX(100%)
    }

    &.sl-notification-fade-enter.left {
      left: 0;
      transform: translateX(-100%)
    }

    &.sl-notification-fade-leave-active {
      opacity: 0;
    }
    .sl-notification__close {
      cursor: pointer;
      text-align: right;
    }
  }
 

</style>

<style lang="scss"> 
/***
  改样式未方便写在组件里
***/
.relearn-notify {
  width: 306px;
  height: 117px;
  background-image: url('./images/totify_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0 !important;
  box-shadow: none !important;
  border: none !important;
  background-color: transparent !important;
  .sl-notification__group {
    padding: 20px 25px 0 25px;
    .sl-notification__content {
      font-size:14px !important;
      font-family:PingFangSC-Regular,PingFang SC !important;
      font-weight:400 !important;
      color:rgba(22,36,56,1) !important;
      line-height:22px !important;
    }
    .sl-notification__close {
      font-size:16px !important;
      font-family:PingFangSC-Medium,PingFang SC !important;
      font-weight:500 !important;
      color:rgba(0,178,255,1) !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Notification/index.vue